/* eslint-disable react/prop-types, @typescript-eslint/no-explicit-any */
import React from 'react';

import { Col, Row } from 'antd';
import { useSelector } from 'react-redux';

import LookaheadFilterHeader from '#components/LookaheadFilterHeader/index.js';
import { lookaheadActions } from '#redux/actions/lookaheadActions.js';
import { viewService } from '#services/views.service.js';
import { ExtraItemsFilter } from './ExtraItemsFilter.jsx';
import { viewType } from './index.helper.js';

export function FilterHeader({
  activeActivityTreePane,
  activeExportPdfModal,
  activeLookAheadReportModal,
  activities,
  activitiesHidden,
  changeDateState,
  changeVisualizationHandle,
  dateRange,
  defaultView,
  gantt,
  groupBy,
  indicators,
  indicatorVisible,
  isLoading,
  isWeeklyCommited,
  lastLevelActivitiesCard,
  listView,
  modifyGroupBy,
  resourcesCard,
  setActiveActivityTreePane,
  setDateRange,
  setExistFilter,
  setIndicatorVisible,
  setIsShowPreview,
  subContracts,
  t,
  tableConfig,
  toSelectResponsables,
  toSelectTags,
  updateRender,
  updateTableMetadata
}) {
  const projectState: any = useSelector<any>((state) => state.projectState);

  if (isLoading) {
    return null;
  }

  const groupQuery = groupBy;
  return (
    <Row>
      <Col>
        <LookaheadFilterHeader
          setDateRange={setDateRange}
          viewType={viewType}
          viewService={viewService}
          isPlanification
          disableColumnsSelector={defaultView.current?.name === 'takt'}
          currentProject={projectState.allProjects.find(
            (el) => el.id === projectState.projectSelected
          )}
          isWeeklyCommited={isWeeklyCommited}
          ganttDhtmlx={gantt}
          visualizationOp={defaultView.current}
          updateDefaultViewFilters={(filterType, value) =>
            (defaultView.current[filterType] = value)
          }
          defaultView={defaultView.current}
          defaultOrderOptions={[
            {
              name: 'activityId',
              label: t('activity_id'),
              switch: ['1 → 9', '9 → 1']
            }
          ]}
          renderExtraFilterRigth={() => (
            <ExtraItemsFilter
              {...{
                tableConfig,
                indicatorVisible,
                setIndicatorVisible,
                indicators,
                t
              }}
            />
          )}
          lookaheadActions={lookaheadActions}
          lookaheadState={'lookaheadState'}
          groupBy={groupQuery}
          setIsFilter={setExistFilter}
          modifyGroupBy={modifyGroupBy}
          data={activities}
          dateReportActive={activeLookAheadReportModal}
          exportPDFGantt={activeExportPdfModal}
          lastLevelActivities={lastLevelActivitiesCard}
          changeDateState={changeDateState}
          dateRange={dateRange}
          updateTableMetadata={updateTableMetadata}
          tableMetadata={
            defaultView.current?.columns_json?.settings || tableConfig
          }
          subContracts={subContracts}
          toSelectResponsables={toSelectResponsables}
          toSelectTags={toSelectTags}
          updateRender={updateRender}
          gantt={gantt}
          changeVisualization={changeVisualizationHandle}
          listViews={listView}
          resources={resourcesCard}
          setActiveActivityTreePane={setActiveActivityTreePane}
          activitiTreePane={activeActivityTreePane}
          setIsShowPreview={setIsShowPreview}
          place={'lookahead'}
          activitiesHidden={activitiesHidden}
        />
      </Col>
    </Row>
  );
}
